import PlanEntryActiveListRequest, {
  PlanEntryActiveListRequestQueryParams,
} from "./plan-entry-active-list.request";

const createQueryParams = (
  request: PlanEntryActiveListRequest,
): PlanEntryActiveListRequestQueryParams => {
  return {
    taxiCorporationId: request.taxiCorporationId,
    cargoOrderId: request.cargoOrderId,
    cargoOrderHumanId: request.cargoOrderHumanId,
  };
};

const planEntryActiveListRequestFactory = { createQueryParams };

export default planEntryActiveListRequestFactory;
